var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "What We Do",
      "tabActive": "Smart Factory",
      "bg": "/images/sub/visual/sv4.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "page-tit-wrap"
  }, [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Smart Factory ")]), _c('p', [_vm._v(" Application of ICT (Information Communication Technology) that combines digital automation solutions in the production process. "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v(" Introduction of processes that collect process data in real time and analyze themselves through IoT ")])])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Field Data Aggregation"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-none d-md-block",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img1-en.png",
      "max-width": "946"
    }
  }), _c('v-img', {
    staticClass: "mx-auto d-block d-md-none",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img1-mo-en.png",
      "max-width": "484"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('sub-line-layout', {
    attrs: {
      "tit": "Data Aggregation Department"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-none d-md-block",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img2-en.png",
      "max-width": "896"
    }
  }), _c('v-img', {
    staticClass: "mx-auto d-block d-md-none",
    attrs: {
      "src": "/images/sub/wwd/factory/factory-img2-mo-en.png",
      "max-width": "624"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }